// @ts-nocheck

/* Management of all active recipes */

import React, {useState, useEffect} from "react";
import {useAtom, useAtomValue} from "jotai";

import {logState} from "../utils";
import {nextRecipe} from "../state/recipes";
import {setActive, loadRecipe, activesAtom, focusedAtom, sessionIdAtom} from "../state/active";
import {SERVER, COOKING_SERVER} from "../utils";
import styles from "./Recipes.module.css";
import gStyles from "../App.module.css";
Object.assign(styles, gStyles);

// Component that displays a single recipe button in the recipes bar
const RecipeBtn = ({r}) => {
  const [focused, setFocused] = useAtom(focusedAtom);
  const [actives, setActives] = useAtom(activesAtom);

  const classes = [styles.active, r.name === focused ? styles.focused : ""].join(" ");
  const props = {style: {backgroundColor: r.color, opacity:1}};
  if (r.name !== focused) {
    props.onClick = () => setFocused(r.name);
    props.style.opacity = 0.5;
    props.style.cursor = "pointer";
  }
  const iconStyle = {
    position: "relative",
    width: 15,
    height: 15,
    top: 1,
  };
  // remove this recipe from the list of active recipes
  const deleteRecipe = () => {
    // if it's the only recipe, don't do anything
    if (Object.keys(actives).length === 1) {
      return;
    }
    const newActives = {...actives};
    delete newActives[r.name];
    setActives(newActives);
    // also set a different recipe as focused if it was this one
    if (r.name === focused) {
      setFocused(Object.keys(newActives)[0]);
    }
  }

  return (
    <div key={r.dish.id} className={classes} {...props}>
      <img src="/icons/delete.png" onDoubleClick={deleteRecipe} style={{marginRight: 3, ...iconStyle}} />
      {r.name}
    </div>
  );
}


export function Recipes() {
  console.log('top of recipes');
  const actives = useAtomValue(activesAtom);
  const [url, setUrl] = useState(window.location.href);
  const sessionId = useAtomValue(sessionIdAtom);

  const loadedRecipeIds = Object.keys(actives).map((k) => actives[k].dish.id);

  const sep = ',';

  // every time url changes, check if we have a new recipe to load
  useEffect(() => {
    // check url ?r=<id> to call server to fetch active recipe
    const url = new URL(window.location.href);
    const recipeIds = url.searchParams.get("r").split(sep);
    console.log('recipeIds', actives, recipeIds, url, url.searchParams.get("r"));
    for (const recipeId of recipeIds){
      if (recipeId && !loadedRecipeIds.includes(recipeId)){
        loadRecipe(recipeId);
      }
    }
    logState({_name: "recipes-url", url, recipeIds, sessionId});
  }, [url]);

  // listen for messages from cooking server (once)
  useEffect(() => {
    const handler = window.addEventListener('message', (ev) => {
      if (ev.origin.includes('neerajkumar.org') && ev.data.url){
        const {url} = ev.data;
        console.log('got a new url from', ev.origin, ev.data);
        if (url.includes('r=')){
          // add it to our r= search params with a comma
          const id = url.split('r=')[1];
          const newUrl = new URL(window.location.href);
          const recipeIds = newUrl.searchParams.get("r").split(sep);
          if (!recipeIds.includes(id)){
            recipeIds.push(id);
            newUrl.searchParams.set("r", recipeIds.join(','));
            window.history.pushState({}, '', newUrl);
            setUrl(newUrl);
          }
        }
      }
    });
    return () => window.removeEventListener('message', handler);
  }, []);

  const iconStyle = {
    position: "relative",
    width: 15,
    height: 15,
    top: 4,
  };
  const classes = [styles.recipes, styles.navbar].join(" ");

  return (
    <div className={classes}>
      <img src="/icons/recipe-book.png" style={iconStyle} />
      <img src="/icons/play.png" style={iconStyle} />
      <img src="/icons/prev.png" style={iconStyle} id="prevBtn" onClick={() => nextRecipe(-1)} />
      <div className={styles.activeList}>
        {Object.keys(actives).map((k) => <RecipeBtn key={k} r={actives[k]} />)}
      </div>
      <img src="/icons/next.png" style={iconStyle} id="nextBtn" onClick={() => nextRecipe(1)} />
    </div>
  );
}
